import React from 'react';

export const IconTick = ({
  handleClick = false,
  stroke = '#000',
  ...props
}) => (
  <svg
    className='icon-tick'
    fill='none'
    viewBox='0 0 10 10'
    onClick={() => (handleClick ? handleClick() : null)}
    {...props}>
    <path
      d='M8.75 2L3.5 8L1.25 5.75'
      stroke={stroke}
      strokeLinecap='square'
      strokeWidth='1.5'
    />
  </svg>
);

export default IconTick;
